import { createColumnHelper } from '@tanstack/react-table'
import { getConsolidateInvoiceDescription } from '../../../../../../utils/getConsolidateInvoiceDescription'
import type { Toll } from '../../../../../../types'
import { NavLink } from 'react-router-dom'
import { formatNumber } from '../../../utils/formatNumber'
import { formatCurrency } from '../../../utils/formatCurrency'

export default function tollReportTableColumns({
  chosenCompany,
  handleSetConsolidateInvoice,
}: {
  chosenCompany?: string
  handleSetConsolidateInvoice: (value: string) => void
}) {
  const columnHelper = createColumnHelper<Toll>()
  return [
    columnHelper.accessor('tYear', {
      id: 'period',
      sortingFn: 'alphanumeric',
      header: 'Periode',
      cell: (row) => (
        <NavLink
          onClick={() => {
            handleSetConsolidateInvoice(row.row.original.consolidatedInvoiceAgreement)
          }}
          className="flex w-fit text-interaction hover:underline hover:text-interactionHover"
          to={`/reports/toll/${row.row.original.tYear}-${row.row.original.tMonth}`}
        >
          {`${row.row.original.tYear} - ${row.row.original.tMonth}` || ''}
        </NavLink>
      ),
    }),
    columnHelper.accessor('consolidatedInvoiceAgreement', {
      id: 'consolidatedInvoiceAgreement',
      enableSorting: false,
      header: 'Samlefakturakode',
      cell: (row) => getConsolidateInvoiceDescription(row.getValue(), chosenCompany) || '',
    }),
    columnHelper.accessor('amountIncVAT', {
      id: 'amountIncVAT',
      sortingFn: 'alphanumeric',
      meta: {
        mobileFooterLabel: 'Sum av beløp',
        alignmentType: 'right',
      },
      header: 'Beløp',
      cell: (row) => formatCurrency(row.getValue()) || '',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('amountIncVAT') as number) || 0), 0)
        return formatCurrency(total)
      },
    }),
    columnHelper.accessor('antallPasseringer', {
      id: 'antallPasseringer',
      sortingFn: 'alphanumeric',
      meta: {
        mobileFooterLabel: 'Totalt antall passeringer',
        alignmentType: 'right',
      },
      header: 'Antall passeringer',
      cell: (row) => formatNumber(row.getValue()) || '',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('antallPasseringer') as number) || 0), 0)
        return formatNumber(total)
      },
    }),
  ]
}
